import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=a2dc6ed8&scoped=true"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=a2dc6ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc6ed8",
  null
  
)

export default component.exports